import styled from 'styled-components';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import AppCard from 'ecosystem-marketplace-core/components/cards/AppCard';
// @ts-expect-error untyped import
import { getIsNewOffering } from 'ecosystem-marketplace-core/utils/offerings';
import { getHasAppCertificationCredential } from 'marketplace-ui-apps-core/common/utils/Certification';
import { useIsMpdi0001Group } from '../../../hooks/useIsMpdi0001Group';
// @ts-expect-error untyped import
import { getListingDetailUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ResultCard__StyledRouterLink",
  componentId: "sc-1rsqyrv-0"
})(["display:flex;align-items:stretch;"]);
const StyledAppCard = styled(AppCard).withConfig({
  displayName: "ResultCard__StyledAppCard",
  componentId: "sc-1rsqyrv-1"
})(["&&{border:2px solid transparent;transition:border ", " ease-out;&:hover{border-color:", ";}}"], MICRO_TRANSITION_TIMING, CALYPSO_MEDIUM);
const ResultCard = ({
  onClick,
  result,
  superCategory
}) => {
  const {
    category,
    companyName,
    credentials,
    firstPublishedAt,
    iconUrl,
    installed,
    installsCount,
    name,
    recommended,
    slug,
    tagline
  } = result;
  const showIsNewApp = getIsNewOffering(firstPublishedAt);
  const isMpdi0001Badge = useIsMpdi0001Group({
    group: 'badge'
  });
  const hasRecommendedBadge = isMpdi0001Badge && recommended === true;
  return /*#__PURE__*/_jsx(StyledRouterLink, {
    "data-test-id": "result-card",
    onClick: onClick,
    to: getListingDetailUrl(slug, category, superCategory),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledAppCard, {
      certified: getHasAppCertificationCredential(credentials),
      className: "m-bottom-0",
      companyName: companyName,
      hasRecommendedBadge: hasRecommendedBadge,
      iconUrl: iconUrl,
      installed: installed,
      installsCount: installsCount,
      name: name,
      showIsNewApp: showIsNewApp,
      tagline: tagline
    })
  });
};
export default ResultCard;